module.exports = __webpack_public_path__ + "static/media/error404.f538d2c2.svg";